var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import Action from './Action';
import { SelectableItemsContainer } from './base/SelectableItemsContainer';
/**
 * @hidden
 */
var ActionGroup = /** @class */ (function (_super) {
    __extends(ActionGroup, _super);
    function ActionGroup(props) {
        return _super.call(this, props) || this;
    }
    ActionGroup.prototype.render = function () {
        var _this = this;
        var lastItemIndex = this.props.group.actions ? this.props.group.actions.length - 1 : 0;
        return (React.createElement("div", { className: this.getClassNames(), onClick: this.onRequestContainerSelection, onKeyDown: this.onKeyDown }, this.props.group.actions && this.props.group.actions.map(function (item, index) {
            return (React.createElement(Action, { item: item, onActionExecute: _this.props.onActionExecute, selected: index === _this.state.selectedItemIndex, tabbable: _this.props.isLastGroup && index === _this.state.selectedItemIndex, isFirstItemInGroup: index === 0, isLastItemInGroup: index === lastItemIndex, key: index }));
        })));
    };
    ActionGroup.prototype.getClassNames = function () {
        return classNames('k-quick-replies');
    };
    return ActionGroup;
}(SelectableItemsContainer));
export default ActionGroup;
